module.exports = __webpack_public_path__ + "static/media/20240401_144202.c80065be.jpg";